
import React from 'react';
import Slider from "react-slick";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BaseUrl } from "../../helper/BaseUrl";
import { toast } from "react-toastify";

const settings = {
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  pauseOnHover: false,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 5000,
  speed: 1000,
  cssEase: "ease",

  beforeChange: () => {
    const imgs = document.querySelectorAll(".banner-img");
    imgs.forEach((img) => img.classList.remove("fadeImg"));
  },

  afterChange: (index) => {
    const activeImg = document.querySelector(`.banner-img[data-index="${index}"]`);
    if (activeImg) activeImg.classList.add("fadeImg");
  },

  prevArrow: (
    <button className="slick-arrow slick-prev" aria-label="Previous Slide">
      <i className="fa-solid fa-arrow-left"></i>
    </button>
  ),
  nextArrow: (
    <button className="slick-arrow slick-next" aria-label="Next Slide">
      <i className="fa-solid fa-arrow-right"></i>
    </button>
  ),
};


export default function HomeBanner() {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
  });


    // ⭐ First slide animation fix
  useEffect(() => {
    const firstImg = document.querySelector('.banner-img[data-index="0"]');
    if (firstImg) {
      setTimeout(() => {
        firstImg.classList.add("fadeImg");
      }, 100);
    }
  }, []);

  // useEffect(() => {
  //   // Store landing page URL
  //   const existingSource = sessionStorage.getItem("source_url");
  //   if (!existingSource) {
  //     const landingUrl = window.location.href;
  //     sessionStorage.setItem("source_url", landingUrl);
  //     setFormData((prev) => ({
  //       ...prev,
  //       source_url: landingUrl,
  //     }));
  //   } else {
  //     setFormData((prev) => ({
  //       ...prev,
  //       source_url: existingSource,
  //     }));
  //   }

  //   // Fetch IP address
  //   fetch("https://api.ipify.org?format=json")
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setFormData((prev) => ({
  //         ...prev,
  //         ip_address: data.ip,
  //       }));
  //     })
  //     .catch((err) => {
  //       console.error("Failed to fetch IP address", err);
  //     });
  // }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email) {
      toast.error("Please enter your email");
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${BaseUrl}/api/newsletter/store`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.error === false) {
        navigate("/thank-you");
      } else {
        toast.error(result.message || "Failed to subscribe.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong while submitting the form.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>

      <section className="theme-banner">
        <div className="theme-inner">
          {/* Slider */}
          <div className="theme-banner-slider">
            <Slider {...settings}>
              {/* Slide 1 */}
              <div className="banner-col">
                <div className="banner-inner">
                  <div className="banner-wrap">
                    <img
                      src="/assets/images/banner-slider-image1.webp"
                      className="img-responsive banner-img"
                      data-index={0}
                      alt="Slider"
                      width="1920"
                      height="800"
                      loading="eager"
                      fetchPriority="high"
                    />
                  </div>
                  <div className="banner-content">
                    <div className="content-inner">
                      <h1 className="heading">
                        Effortless Logistics & Warehousing
                      </h1>
                      <p>
                        Simplifying supply chain operations with seamless storage,
                        fast deliveries, and optimized efficiency.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Slide 2 */}
              <div className="banner-col">
                <div className="banner-inner">
                  <div className="banner-wrap">
                    <img
                      src="/assets/images/banner-slider-image2.webp"
                      className="img-responsive banner-img"
                      data-index={1}
                      alt="Slider"
                      width="1920"
                      height="800"
                      loading="lazy"
                      fetchPriority="low"
                    />

                   
                  </div>
                  <div className="banner-content">
                    <div className="content-inner">
                      <h1 className="heading">
                        Smart Logistics. Swift Deliveries. Seamless Storage.
                      </h1>
                      <p>
                        Transform your supply chain with advanced warehousing solutions and efficient distribution networks that keep your business moving.
                      </p>
                    </div>
                  </div>
                </div>
              </div>


              <div className="banner-col">
                <div className="banner-inner">
                  <div className="banner-wrap">
                    <img
                      src="/assets/images/banner-slider-image3.webp"
                      className="img-responsive banner-img"
                      data-index={2}
                      alt="Slider"
                      width="1920"
                      height="800"
                      loading="lazy"
                      fetchPriority="low"
                    />
                  </div>
                  <div className="banner-content">
                    <div className="content-inner">
                      <h1 className="heading">
                        Next-Gen Distribution Networks

                      </h1>
                      <p>
                        Driving growth through reliable storage, advanced technology, and on-time fulfillment.

                      </p>
                    </div>
                  </div>
                </div>
              </div>


              <div className="banner-col">
                <div className="banner-inner">
                  <div className="banner-wrap">
                    <img
                      src="/assets/images/banner-slider-image4.webp"
                      className="img-responsive banner-img"
                      data-index={3}
                      alt="Slider"
                      width="1920"
                      height="800"
                      loading="lazy"
                      fetchPriority="low"
                    />
                  </div>
                  <div className="banner-content">
                    <div className="content-inner">
                      <h1 className="heading">
                        Smart Fulfillment Services

                      </h1>
                      <p>
                        Simplifying operations with secure storage, swift dispatch, and streamlined supply chains.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Slider>
          </div>

          {/* Form */}
          <div className="banner-form">
            <div className="form-inner">
              <form onSubmit={handleSubmit}>
                <fieldset className="fieldInput">
                  <input type="email" required className="form-input form-control" name="email" value={formData.email} onChange={handleChange} placeholder="Enter business email" />
                  <button disabled={loading} type="submit" className="form-submit" >
                    {loading ? "Submitting..." : "Book A Demo"}
                  </button>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
